import StringHelpers from './StringHelpers'
import {format} from 'date-fns'


export default class {

    //takes an event and gets its dom elemnt and works out the 'order' of it once inserted between 2 others.

    static getAverageOrder(e) {
        let prevOrder, nextOrder, newOrder
 
        if(e.item.previousSibling && e.item.previousSibling.dataset.order) //dom must use lowercase
            prevOrder = e.item.previousSibling.dataset.order
  
        console.log('prevOrder', StringHelpers.formatNumber(prevOrder))

        if(e.item.nextSibling && e.item.nextSibling.dataset.order)
            nextOrder = e.item.nextSibling.dataset.order

        console.log('nextOrder', StringHelpers.formatNumber( nextOrder))

        if(!prevOrder)
            newOrder = 0 - StringHelpers.sortKey() + 1000
        else if(!nextOrder)
            newOrder = StringHelpers.sortKey()
        else
            newOrder = Math.round((parseInt(prevOrder) + parseInt(nextOrder))/2)

        e.item.dataset.order = newOrder
        
        console.log('newOrder', StringHelpers.formatNumber(newOrder))

        return newOrder  
    }

    static orderKey () {
        return parseInt(format(new Date(), 'yyMMddHHmmss')) * 100
    }

    static sortAscending(a, b) {
        if(b.alwaysLast) {
            return -1
        }
        if(a.alwaysLast) {
            return 1
        }

        if (!a.order || a.order < b.order) {
          return -1
        }
        if (!b.order || a.order > b.order) {
          return 1
        }
        return 0;
    }

    static sortByTimestampDescending(a, b) {

      if (!b.stamp || !b.stamp.date || b.stamp.date < a.stamp.date) {
        return -1
      }
      if (!a.stamp || !a.stamp.date || b.stamp.date > a.stamp.date) {
        return 1
      }
      return 0;
    }
    static sortByCreatedAtDescending(a, b) {

      if (!b.createdAt.seconds || !b.createdAt.seconds || b.createdAt.seconds < a.createdAt.seconds) {
        return -1
      }
      if (!a.createdAt.seconds || !a.createdAt.seconds || b.createdAt.seconds > a.createdAt.seconds) {
        return 1
      }
      return 0;
    }
    static sortByOpenedAtDescending(a, b) {

      if (!b.openedAt || b.openedAt < a.openedAt) {
        return -1
      }
      if (!a.openedAt || b.openedAt > a.openedAt) {
        return 1
      }
      return 0;
    }
    static sortByDate(a, b) {

        if (!a.date || a.date < b.date) {
          return -1
        }
        if (!b.date || a.date > b.date) {
          return 1
        }
        return 0;
    }

    static sortByName (a, b) {

        if (!a.name || a.name < b.name) {
          return -1
        }
        if (!b.name || a.name > b.name) {
          return 1
        }
        return 0;
    }
    static sortByTitle (a, b) {

        if (!a.title || a.title < b.title) {
          return -1
        }
        if (!b.title || a.title > b.title) {
          return 1
        }
        return 0;
    }
    static sortByOrder (a, b) {

        if (!a.order || a.order < b.order) {
          return -1
        }
        if (!b.order || a.order > b.order) {
          return 1
        }
        return 0;
    }

    static sortByField (a, b, field) {
      if (!a[field] || a[field] < b[field]) {
        return -1
      }
      if (!b[field] || a[field] > b[field]) {
        return 1
      }
      return 0;
  }
    
    


}


// WEBPACK FOOTER //
// ./src/helpers/OrderHelpers.js